import Switch from './Switch'

export default Switch



// WEBPACK FOOTER //
// ./components/vc-switch/index.js